import { ColorProps } from 'types';

// ==============================|| THEME 4 COLORS ||============================== //

const theme4: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#e3e8e8',
  primaryMain: '#173e43',
  primaryDark: '#14383d',
  primary200: '#8b9fa1',
  primary800: '#0d282c',

  // secondary
  secondaryLight: '#e8f6f5',
  secondaryMain: '#3fb0ac',
  secondaryDark: '#39a9a5',
  secondary200: '#9fd8d6',
  secondary800: '#299792',

  // success
  successLight: '#b9f6ca',
  success200: '#69f0ae',
  successMain: '#00e676',
  successDark: '#00c853',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#04151f',
  darkBackground: '#030708',

  // dark 800 & 900
  darkLevel1: '#02131d',
  darkLevel2: '#051114',

  // text variants
  darkTextTitle: '#ffffff',
  darkTextPrimary: '#ffffff',
  darkTextSecondary: '#ccd2eb',

  // primary dark
  darkPrimaryLight: '#e3e8e8',
  darkPrimaryMain: '#3a5b5f',
  darkPrimaryDark: '#14383d',
  darkPrimary200: '#8b9fa1',
  darkPrimary800: '#0d282c',

  // secondary dark
  darkSecondaryLight: '#e8f6f5',
  darkSecondaryMain: '#3fb0ac',
  darkSecondaryDark: '#39a9a5',
  darkSecondary200: '#9fd8d6',
  darkSecondary800: '#299792'
};

export default theme4;
